module.exports = __webpack_public_path__ + "static/img/job.7528781a.png";